import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import StyledContainer from './styled/index'
import Checkbox from '../input/input-checkbox'

const CheckboxGroup = (props) => {
  const {
    options,
    className,
    style,
    onChange,
    name,
    readonly,
    size = 'md',
    checkedValues = [],
    direction = 'col',
  } = props

  if (!(options && options.length)) {
    return null
  }

  return (
    <StyledContainer
      className={clsx(
        {
          'flex flex-row': direction === 'row',
          'flex flex-col': direction !== 'row',
        },
        className
      )}
      style={style}
    >
      {options.map((item, index) => {
        return (
          <Checkbox
            key={`checkbox-${index}-${item.value}`}
            name={name}
            value={item.value}
            onChange={(e) => {
              let arr = [...checkedValues]
              if (e.target.checked) {
                arr.push(e.target.value)
              } else {
                arr = arr.filter((v) => v !== e.target.value)
              }

              onChange(arr)
            }}
            size={size}
            readonly={readonly}
            label={item.label}
            defaultChecked={
              item.defaultChecked || checkedValues.includes(item.value)
            }
            checked={checkedValues.includes(item.value)}
            disabled={item.disabled}
          />
        )
      })}
    </StyledContainer>
  )
}

CheckboxGroup.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape(PropTypes.object),
  name: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      value: PropTypes.string,
      disabled: PropTypes.bool,
      description: PropTypes.string,
    })
  ),
  checkedValues: PropTypes.arrayOf(PropTypes.string),
  direction: PropTypes.oneOf(['row', 'col']),
}
CheckboxGroup.defaultProps = {
  className: undefined,
  style: undefined,
  name: undefined,
  readonly: false,
  onChange: () => {},
  size: 'md',
  options: [],
  checkedValues: [],
  direction: 'col',
}

export default CheckboxGroup
